<script setup lang="ts">
import { AlertCircle, CheckCircle2, Loader2 } from 'lucide-vue-next';

type Status = 'idle' | 'loading' | 'success' | 'error';

type Props = {
    status: Status;
    message?: string;
};

withDefaults(defineProps<Props>(), {
    message: '',
});
</script>

<template>
    <div
        v-if="status !== 'idle'"
        class="mt-4 flex items-start gap-2 rounded-lg px-3 py-2.5 text-xs font-medium sm:px-4 sm:py-3 sm:text-sm"
        :class="{
            'bg-blue-50 text-blue-700 dark:bg-blue-950 dark:text-blue-300':
                status === 'loading',
            'bg-green-50 text-green-700 dark:bg-green-950 dark:text-green-300':
                status === 'success',
            'bg-red-50 text-red-700 dark:bg-red-950 dark:text-red-300':
                status === 'error',
        }"
    >
        <Loader2
            v-if="status === 'loading'"
            class="mt-0.5 size-4 shrink-0 animate-spin sm:mt-px"
        />
        <CheckCircle2
            v-else-if="status === 'success'"
            class="mt-0.5 size-4 shrink-0 sm:mt-px"
        />
        <AlertCircle
            v-else-if="status === 'error'"
            class="mt-0.5 size-4 shrink-0 sm:mt-px"
        />
        <span class="min-w-0 flex-1 break-words">{{
            message || (status === 'loading' ? 'Processing...' : '')
        }}</span>
    </div>
</template>
